import { sleep } from "../../../../library-js/animation/sleep";
import { ElementType } from "../../../../library-js/dom-tools/ElementType";
import { AnimatableElement } from "../AnimatableElement";
import { CarouselElement, CarouselElementMode } from "../CarouselElement";
import { CarouselSelect } from "../CarouselSelect";

export class SlideUp extends CarouselElement
{  
  static readonly type        = new ElementType( "slide-up" );
  static readonly bgElement   = new ElementType( "bg-element" );
  static readonly textElement = new ElementType( "text-element" );
  
  constructor( s:CarouselSelect, e:Element )
  {
    super( s, e, CarouselElementMode.Portrait );
    this.grabElements();
  }

  bg:HTMLElement;
  hero:HTMLElement;
  text:HTMLElement;
  cta:HTMLElement;

  grabElements()
  {
    this.bg   = SlideUp.bgElement.query( this._element ) as HTMLElement;
    this.text = SlideUp.textElement.query( this._element ) as HTMLElement;
    this.cta  = CarouselSelect.ctaElement.query( this._element ) as HTMLElement;
  }

  static readonly _inFromTransform = "translate3d(0,calc( var(--sw ) * 3),0)";
  static readonly _inFromTransform2 = "translate3d(0,calc( var(--sw ) * 2),0)";
  static readonly _inToTransform  = "translate3d(0,0,0)";

  static readonly _outTransform = "translate3d(0,calc( var(--sw ) * -2),0)";

  async transitionIn():Promise<void>
  {
    
    let layers:AnimatableElement[] = 
    [
      { element:this.text, keys:
        [ 
         { attribute:"transform", from: SlideUp._inFromTransform, to:SlideUp._inToTransform },
         { attribute:"opacity", from: "0", to:"1" }
        ] 
      },
      { element:this.cta, keys:
        [ 
          { attribute:"transform", from:SlideUp._inFromTransform2, to:SlideUp._inToTransform },
          { attribute:"opacity", from:"0", to:"1" }
        ] 
      }
    ];

    AnimatableElement.animate( layers );
    

    await sleep( this.transitionOutDurationMs );
    return Promise.resolve();
  }

  async transitionOut():Promise<void>
  {
    this.text.style.transform = SlideUp._outTransform;
    this.cta.style.transform  = SlideUp._outTransform;
    this.text.style.opacity = "0";
    this.cta.style.opacity  = "0";

    await sleep( this.transitionOutDurationMs );
    return Promise.resolve(); 
  }
}